import React from "react";
import { Button } from "antd";
import { ArrowRight } from "lucide-react";

export function NavigateButton(props) {
  return (
    <Button type="default" className="!flex items-center gap-2" {...props}>
      <p className="my-0 text-sm block">{props.children}</p>
      <ArrowRight strokeWidth={1.5} size={16} />
    </Button>
  );
}
